export const hydrationWrapperPrefix = "__IDUN_HYDRATION_WRAPPER_";
export const ssrOnlyPortionIdDataKey = "data-ssr-only-portion-id"
export const hydrationCompleteEventName = "__IDUN_HYDRATION_COMPLETE__"